<template>
  <div class="placeholder-wrapper">
    <!-- PROMO PLACEHOLDER -->
    <div class="promo-placeholder">
      <div v-for="index in 2" :key="index" class="element-placeholder">
        <div class="short placeholder"></div>
        <div class="long placeholder"></div>
      </div>
    </div>
    <!-- RECENTLY SEARCHED & TRENDING SEARCH PLACEHOLDER -->
    <div class="recent-search-placeholder">
      <div v-for="index in 2" :key="index" class="element-placeholder">
        <div class="top">
          <div class="left placeholder"></div>
          <div v-if="index === 1" class="right placeholder"></div>
        </div>
        <div class="bottom-wrapper">
          <div v-for="index_bottom in 4" :key="`${index}-${index_bottom}`" class="bottom placeholder"></div>
        </div>
      </div>
    </div>
    <!-- BRAND & PRODUCT TABS PLACEHOLDER -->
    <div class="tabs-placeholder">
      <div class="header element-placeholder">
        <div v-for="index in 2" :key="index" class="placeholder"></div>
      </div>
      <div class="brands element-placeholder">
        <div v-for="index in 4" :key="index" class="placeholder"></div>
      </div>
      <div v-for="index in 4" :key="index" class="product element-placeholder">
        <div class="product-image placeholder"></div>
        <div class="product-info">
          <div class="linear placeholder"></div>
          <div class="linear placeholder"></div>
          <div class="linear placeholder"></div>
        </div>
        <div class="product-rating placeholder"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchPlaceholder',
};
</script>

<style lang="scss" scoped>
.placeholder-wrapper {
  padding: 16px;
  .promo-placeholder {
    margin-bottom: 24px;
    .element-placeholder {
      display: flex;
      align-items: center;
      &:not(:last-child) {
        margin-bottom: 12px;
      }
      .short {
        border-radius: 6.5px;
        height: 13px;
        width: 37px;
      }
      .long {
        border-radius: 4px;
        flex: 1;
        margin-left: 12px;
        height: 19px;
      }
    }
  }
  .recent-search-placeholder {
    margin-bottom: 22px;
    .element-placeholder {
      &:not(:last-child) {
        margin-bottom: 24px;
      }
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 11px;
        justify-content: space-between;
        .placeholder {
          border-radius: 4px;
          height: 17px;
        }
        .left {
          width: 143px;
        }
        .right {
          width: 44px;
        }
      }
      .bottom-wrapper {
        display: flex;
        align-items: center;
        .bottom {
          border-radius: 16px;
          width: 102px;
          height: 32px;
          flex: 1;
          &:not(:last-child) {
            margin-right: 4px;
          }
        }
      }
    }
  }
  .tabs-placeholder {
    .header.element-placeholder {
      display: flex;
      margin-bottom: 16px;
      .placeholder {
        border-radius: 4px;
        height: 17px;
        width: 101px;
        margin-right: 16px;
      }
    }
    .brands.element-placeholder {
      display: flex;
      align-items: center;
      margin-bottom: 28px;
      .placeholder {
        border-radius: 3.64px;
        height: 48px;
        width: 87px;
        margin-right: 8px;
      }
    }
    .product.element-placeholder {
      display: flex;
      align-items: flex-start;
      width: 100%;
      &:not(:last-child) {
        margin-bottom: 24px;
      }
      .product-image.placeholder {
        height: 40px;
        border-radius: 4px;
        width: 40px;
        margin-right: 8px;
      }
      .product-info {
        flex: 1;
        .linear.placeholder {
          height: 15px;
          margin-bottom: 3px;
          &:first-child {
            width: 165px;
          }
          &:nth-child(2) {
            width: 300px;
            @media (max-width: 992px) {
              width: 233px;
            }
          }
          &:last-child {
            width: 117px;
          }
        }
      }
      .product-rating.placeholder {
        height: 15px;
        width: 30px;
      }
    }
  }
}
</style>
